"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSaveEvent = useSaveEvent;
var _subscriptionSaved = require("@ori-events/subscription-saved");
var _react = require("react");
function useSaveEvent() {
  const handleSave = (0, _react.useCallback)((...data) => {
    (0, _subscriptionSaved.dispatch)(...data);
  }, []);
  return {
    handleSave
  };
}
